import { render } from "./Presenting.vue?vue&type=template&id=1a1ef22d&scoped=true"
import script from "./Presenting.vue?vue&type=script&lang=js"
export * from "./Presenting.vue?vue&type=script&lang=js"

import "./Presenting.vue?vue&type=style&index=0&id=1a1ef22d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1a1ef22d"

export default script